import type { PlanCountdownParts } from './usePlanCountdown'

type PlanCountdownSegmentsProps = {
  countdownParts: PlanCountdownParts
  digitClassName: string
  unitLabelClassName: string
  shadowClassName: string
}

const COUNTDOWN_SEGMENTS = [
  { key: 'days', label: 'days' },
  { key: 'hours', label: 'hours' },
  { key: 'minutes', label: 'minutes' },
  { key: 'seconds', label: 'seconds' }
] as const

export function PlanCountdownSegments({
  countdownParts,
  digitClassName,
  unitLabelClassName,
  shadowClassName
}: PlanCountdownSegmentsProps) {
  return (
    <div className={`flex items-stretch bg-white rounded-[20px] ${shadowClassName}`}>
      {COUNTDOWN_SEGMENTS.map((segment, segmentIndex) => (
        <CountdownSegment
          key={segment.key}
          value={countdownParts[segment.key]}
          label={segment.label}
          showDividerAfter={segmentIndex === 0}
          digitClassName={digitClassName}
          unitLabelClassName={unitLabelClassName}
        />
      ))}
    </div>
  )
}

export function CountdownSegment({
  value,
  label,
  showDividerAfter = false,
  digitClassName,
  unitLabelClassName
}: {
  value: number
  label: string
  showDividerAfter?: boolean
  digitClassName: string
  unitLabelClassName: string
}) {
  return (
    <div className="relative flex min-w-0 flex-1 flex-col items-center py-4">
      {showDividerAfter ? (
        <div className="absolute right-0 top-0 h-full bottom-3 w-px bg-[#F0F4F7]" aria-hidden />
      ) : null}
      <span className={`text-[32px] font-medium leading-none ${digitClassName}`}>
        {String(value).padStart(2, '0')}
      </span>
      <span className={`mt-[2px] text-[13px] font-normal ${unitLabelClassName}`}>{label}</span>
    </div>
  )
}
